const NOTICE_SECTION_SELECTOR = ".notice-bar-section";
const PENDING_CLASS = "notice-bar-section--pending";
const VISIBLE_CLASS = "notice-bar-section--visible";

export function initNoticeBars() {
	const sections = document.querySelectorAll(NOTICE_SECTION_SELECTOR);

	if (!sections.length) {
		return;
	}

	if (!("IntersectionObserver" in window)) {
		for (const section of sections) {
			section.classList.add(VISIBLE_CLASS);
		}

		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (!entry.isIntersecting) {
					continue;
				}

				entry.target.classList.add(VISIBLE_CLASS);
				observer.unobserve(entry.target);
			}
		},
		{
			threshold: 0.2,
		},
	);

	for (const section of sections) {
		section.classList.add(PENDING_CLASS);
		observer.observe(section);
	}
}
